module.exports = __webpack_public_path__ + "static/media/icon-login-school-signup.fdcfb28e.svg";